// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"d143f5a3","150":"a5e05147","898":"fed30c5f"}[chunkId] + ".chunk.js";
};